import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import clsx from 'clsx';
import { DeleteButtonProps } from './DeleteButton.props';
import { deleteButtonClasses, StyledHtmlTooltip } from './DeleteButton.styles';

const DeleteButton = ({
  deleteText,
  toolTipText = '',
  allowDelete,
  enableDeleteButton,
  handleDelete,
}: DeleteButtonProps) => {
  const htmlTooltipTitle = useMemo(() => {
    const tooltipTitle = allowDelete ? '' : toolTipText;
    return enableDeleteButton ? '' : tooltipTitle;
  }, [allowDelete, toolTipText, enableDeleteButton]);

  return (
    <StyledHtmlTooltip title={htmlTooltipTitle} placement="top">
      <Button
        id="delete-btn"
        className={clsx(
          enableDeleteButton && deleteButtonClasses.dangerButton,
          !enableDeleteButton && deleteButtonClasses.disabledButton,
          deleteButtonClasses.autoMarginRight
        )}
        variant="text"
        color="inherit"
        onClick={enableDeleteButton ? handleDelete : undefined}>
        {deleteText}
      </Button>
    </StyledHtmlTooltip>
  );
};

export default DeleteButton;
